import React from 'react';
import { Input } from 'reactstrap';

import { InputProps } from '~components/form-fields';

const FormInputWorkerNotes: React.FC<InputProps> = ({ value, id, onChange }) => {
  return (
    <div className={`me-4 ${id}`}>
      <Input
        id={id}
        name={id}
        className="default-notes"
        data-cy="notes-input"
        type="textarea"
        value={value}
        rows={5}
        onChange={({ target: { name, value } }) => onChange && onChange(name, value)}
      />
    </div>
  );
};

export default FormInputWorkerNotes;
